import { useMemo } from 'react';
import { defaultTheme, Utils } from '@treezor/design-system';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

export const useApplicationTheme = () => {
  const config = useDashboardConfig();

  const appTheme = useMemo(() => {
    const primaryColor = config?.site?.color;
    if (!primaryColor) return defaultTheme;

    const hoverColor = Utils.hexColorAddOpacity(primaryColor, 0.9);

    return {
      ...defaultTheme,
      palette: { ...defaultTheme.palette, primary: primaryColor, primaryHover: hoverColor, select: primaryColor },
      theme: {
        ...defaultTheme.theme,
        button: {
          ...defaultTheme.theme.button,
          primary: {
            ...defaultTheme.theme.button.primary,
            default: {
              ...defaultTheme.theme.button.primary.default,
              default: {
                ...defaultTheme.theme.button.primary.default.default,
                background: primaryColor,
                border: primaryColor,
              },
              hover: {
                ...defaultTheme.theme.button.primary.default.hover,
                background: hoverColor,
                border: hoverColor,
              },
            },
          },
          secondary: {
            ...defaultTheme.theme.button.secondary,
            default: {
              ...defaultTheme.theme.button.secondary.default,
              default: {
                ...defaultTheme.theme.button.secondary.default.default,
                text: primaryColor,
                border: primaryColor,
              },
              hover: {
                ...defaultTheme.theme.button.secondary.default.hover,
                text: primaryColor,
                border: hoverColor,
              },
            },
          },
        },
        text: { ...defaultTheme.theme.text, interactive: primaryColor },
        border: { ...defaultTheme.theme.border, interactive: primaryColor },
        icon: { ...defaultTheme.theme.icon, primary: primaryColor },
        link: { ...defaultTheme.theme.link, primary: { ...defaultTheme.theme.link.primary, hover: hoverColor } },
      },
    };
  }, [config?.site?.color]);

  return { appTheme, config };
};
